import React from 'react';
import styled from 'styled-components';
import { useTemplate } from '../../context/TemplateContext';

const ElementItem = ({ element, provided, snapshot, onAddElement }) => {
  // Only use drag-and-drop props if provided
  const dragProps = provided ? {
    ref: provided.innerRef,
    ...provided.draggableProps,
    ...provided.dragHandleProps,
    isDragging: snapshot && snapshot.isDragging
  } : {};
  

  
  return (
    <ElementContainer
      {...dragProps}
    >
      <ElementIcon className={`fas fa-${element.icon}`} />
      <ElementInfo>
        <ElementName>{element.name}</ElementName>
        <ElementDescription>{element.description}</ElementDescription>
      </ElementInfo>
      <AddButton onClick={onAddElement} title={`Add ${element.name}`}>
        <i className="fas fa-plus"></i>
      </AddButton>
    </ElementContainer>
  );
};

const ElementContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  margin-bottom: 8px;
  background-color: ${props => props.isDragging ? '#e6f7ff' : '#ffffff'};
  border: 1px solid ${props => props.isDragging ? '#91d5ff' : '#e0e0e0'};
  border-radius: 4px;
  box-shadow: ${props => props.isDragging ? '0 2px 8px rgba(0, 0, 0, 0.15)' : '0 1px 3px rgba(0, 0, 0, 0.05)'};
  cursor: grab;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #91d5ff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
  
  &:active {
    cursor: grabbing;
  }
`;

const ElementIcon = styled.i`
  font-size: 18px;
  color: #5876ff;
  margin-right: 12px;
  width: 20px;
  text-align: center;
`;

const ElementInfo = styled.div`
  flex: 1;
`;

const ElementName = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #333;
`;

const ElementDescription = styled.div`
  font-size: 12px;
  color: #666;
  margin-top: 2px;
`;

const AddButton = styled.button`
  background-color: #5876ff;
  color: white;
  border: none;
  border-radius: 4px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  
  &:hover {
    background-color: #4a67e0;
  }
`;

export default ElementItem;
